import Vue from 'vue';

Vue.component('video-item-detail', {
    props: {
        iFrame: {
            type: String,
            default: ','
        }
    },

    data: function() {
        return {};
    },

    computed: {
        iFrameVideo() {
            return this.iFrame;
        }
    }
});
